export default __webpack_public_path__ + "7fe92bb1fe75c84e473aa3a5fb7c1de9.ttf";